import * as React from 'react'

function SvgTransaction(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.84439 5.11066C4.18803 5.11066 4.46661 4.83208 4.46661 4.48843C4.46661 4.14479 4.18803 3.86621 3.84439 3.86621C3.50075 3.86621 3.22217 4.14479 3.22217 4.48843C3.22217 4.83208 3.50075 5.11066 3.84439 5.11066Z"
        fill="currentColor"
      />
      <path
        d="M15.1333 2H2.86667C1.8 2 1 2.8 1 3.86667V14.8889C1 15.9556 1.8 16.7556 2.86667 16.7556H15.1333C16.2 16.7556 17 15.9556 17 14.8889V3.86667C17 2.8 16.2 2 15.1333 2ZM9.62222 13.1111H6.33333L7.04444 13.8222L6.15556 14.7111L3.93333 12.4889L6.15556 10.2667L7.04444 11.1556L6.33333 11.8667H9.53333V13.1111H9.62222ZM11.8444 12.2222L10.9556 11.3333L11.6667 10.6222H8.37778V9.37778H11.6667L10.9556 8.66667L11.8444 7.77778L14.0667 10L11.8444 12.2222ZM15.7556 5.73333H2.24444V3.86667C2.24444 3.51111 2.51111 3.24444 2.86667 3.24444H15.1333C15.4889 3.24444 15.7556 3.51111 15.7556 3.86667V5.73333Z"
        fill="currentColor"
      />
      <path
        d="M5.97769 5.11066C6.32133 5.11066 6.59991 4.83208 6.59991 4.48843C6.59991 4.14479 6.32133 3.86621 5.97769 3.86621C5.63405 3.86621 5.35547 4.14479 5.35547 4.48843C5.35547 4.83208 5.63405 5.11066 5.97769 5.11066Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgTransaction
